<script>
import Layout from '@layouts/main.vue'
import Timer from '@/src/components/timer.vue'

export default {
  page: {
    title: 'Test',
    meta: [{ name: 'description', content: 'Test.' }],
  },
  components: { Layout, Timer },
  data() {
    return {
      user: {
        name: null,
        password: null,
      },
      gameConfig: {
        dataUrl: '/qagamebuild/Build/deliveryQaBuild.data',
        frameworkUrl: '/qagamebuild/Build/deliveryQaBuild.framework.js',
        codeUrl: '/qagamebuild/Build/deliveryQaBuild.wasm',
        streamingAssetsUrl: 'StreamingAssets',
        companyName: 'LilBubu',
        productName: 'MoveMeee',
        productVersion: '1.0',
      },
      loaderUrl: '/qagamebuild/Build/deliveryQaBuild.loader.js',
      timeLimit: null,
    }
  },
  computed: {
    getTestUser() {
      return this.$store.getters['qa/getTestUser']
    },
    getMessage() {
      return this.$store.getters['qa/getMessage']
    },
  },
  watch: {},
  mounted() {},
  methods: {
    login() {
      this.$store.dispatch('qa/loginTestUser', this.user)
    },
    formatDate(date) {
      var options = {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      }
      if (date !== undefined) {
        return date.toLocaleDateString('en-GB', options)
      } else {
        return false
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div v-if="!getTestUser.loggedIn" class="login">
      <span class="md-title">Log In</span>
      <div class="editusercontent">
        <md-field>
          <label>Name</label>
          <md-input v-model="user.name"></md-input>
        </md-field>
        <md-field>
          <label>Password</label>
          <md-input v-model="user.password" type="password"></md-input>
        </md-field>
      </div>
      <md-button class="loginbtn md-primary md-raised" @click="login"
        >Login</md-button
      >
      <div class="message">{{ getMessage }}</div>
    </div>
    <div v-else class="container">
      <Timer :test-user="getTestUser" @timer-end="$store.dispatch('qa/endSession')" />
      <iframe
        class="iframe"
        src="https://storage.googleapis.com/o7qa-apuelohxagha3taih5s/moveme/index.html"
      />
    </div>
  </Layout>
</template>

<style lang="scss" scoped>
@import '@design';

.iframe {
  width: 100%;
  height: calc(100vh - 150px);
  border: none;
}

.login {
  max-width: 500px;
  margin: 0 auto;

  .editusercontent {}

  .loginbtn {
    margin: 0;
  }

  .message {
    margin-top: 20px;
    font-size: 1.2em;
    font-weight: bold;
    text-align: center;
  }
}
</style>
